import { render, staticRenderFns } from "./BackgroundEnlargeImage.vue.js?vue&type=template&id=2190a035!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BackgroundEnlargeImage.vue?vue&type=template&id=2190a035"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
component.options.__file = "src/components-v2/presentation-editor/middle/BackgroundEnlargeImage.vue"
